/**
 * A drop-in replacement for the baked `variables` token object that returns a `var(--sscs-*)`
 * reference for every token instead of its resolved value, so MUI `styleOverrides` read the runtime
 * token layer (`tokens.module.scss`) and re-theme with it. Palette/typography stay on the real
 * `variables` object because MUI needs concrete colours to derive shades. Tokens are keyed in
 * snake_case; the custom properties use the kebab-case form from `scripts/generate-css-vars.cjs`.
 */
const toKebabCase = (key) => key.replace(/_/g, "-");
export const cssVars = new Proxy({}, {
    get: (_target, key) => typeof key === "string" ? `var(--sscs-${toKebabCase(key)})` : undefined,
});
//# sourceMappingURL=cssVars.js.map